import { giphyWhite } from '@giphy/js-brand'
import { useState } from 'react'
import styled from 'styled-components'

const Container = styled.div`
    float: left;
    display: flex;
    margin-top: 10px;
    margin-left: 14px;
`

const Anchor = styled.a`
    background: linear-gradient(263.55deg, #9933ff -5.88%, #6157ff 194.65%);
    padding: 8.5px 16px;
    display: inline-block;
    background-size: 400% !important;
    border-radius: 2px;

    &:first-child {
        background: linear-gradient(263.31deg, #9933ff -97.49%, #6157ff 94.14%);
        margin-right: 4px;
    }

    span {
        color: ${giphyWhite};
        font-size: 15px;
        font-weight: 600;
    }
`

const CreationButton = () => {
    const [startingMousePosition, setStartingMousePosition] = useState<number>(0)
    const [backgroundPosition, setBackgroundPosition] = useState<number>(-400)

    return (
        <Container
            onMouseEnter={(e) => {
                setStartingMousePosition(e.pageX)
            }}
            onMouseMove={(e) => {
                const mousePositionDiff = e.pageX - startingMousePosition
                const percent = (mousePositionDiff * 100) / 150 - 106

                setBackgroundPosition(percent)
            }}
        >
            <Anchor rel="nofollow" href="/upload" style={{ backgroundPositionX: `${backgroundPosition}px` }}>
                <span>Upload</span>
            </Anchor>
            <Anchor rel="nofollow" href="/create/gifmaker" style={{ backgroundPositionX: `${backgroundPosition}px` }}>
                <span>Create</span>
            </Anchor>
        </Container>
    )
}

export default CreationButton
